import { render, staticRenderFns } from "./editFaqCategory.vue?vue&type=template&id=a6a8cc44&"
import script from "./editFaqCategory.vue?vue&type=script&lang=js&"
export * from "./editFaqCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports